<template>
  <conferencia-list-geral :items="reprovados" />
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ConferenciaListGeral from './ConferenciaListGeral.vue'

export default {
  name: 'ConferenciaListReprovados',
  components: { ConferenciaListGeral },
  computed: {
    ...mapGetters('conferencia', ['reprovados']),
  },
  methods: {
    ...mapActions('conferencia', ['getConferencias']),
    async getItems(params) {
      try {
        await this.getConferencias({ params })
      } catch (e) {
        this.errorMessage(e.response.data)
      }
    },
  },
}
</script>
